<template>
  <div>
    <header class="l-header">
      <div class="inner">
        <div class="logo">
          <template v-if="isLogin">
            <template v-if="!isSupple">
              <a tabindex="1"><img src="@/assets/img/common/logo-set.svg" alt="労務監査クラウド ヨクスル"></a>
            </template>
            <template v-else>
              <a tabindex="1"><img src="@/assets/img/common/logo-roumu-set.svg" alt="労務監査クラウド 労務サプリ"></a>
            </template>
          </template>
        </div>
      </div>
    </header>
    <main id="main">
      <Loading :isProcessing="isProcessing"></Loading>
      <div class="l-contents">
        <h1 class="l-pageTitle">利用規約</h1>
        <div class="l-contentsBox">
          <div class="l-contentsSection">
            <template v-if="!isSupple">
              <Terms
                @done-scrolled="emitScrolled"
              ></Terms>
            </template>
            <template v-else>
              <SuppleTerms @done-scrolled="emitScrolled"/>
            </template>
          </div>
          <div v-show="isLogin" class="l-contentsBox__bottom" style="margin-top:20px; text-align: center;">
            <div class="btn-group">
              <div class="btn-basic is-inlne js-cancel" @click="disagree()" :disabled="isProcessing"><a>同意しない</a></div>
              <div class="btn-basic is-inlne js-save" :class="{ 'gray-out' : !scrolled, 'is-primary' : scrolled }"  @click="agree()" :disabled="!scrolled || isProcessing">
                <a>同意する</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import Terms from '@/components/parts/terms/Terms.vue';
import SuppleTerms from '@/components/parts/terms/SuppleTerms.vue';

export default {
  components: {
    Loading,
    Terms,
    SuppleTerms,
  },
  data() {
    return {
      htmlContent: "",
      isProcessing: false,
      isAdmin: false,
      isSupple: false,
      scrolled: false,
      redirectUrl: '',
    };
  },
  computed: {
    isLogin() {
      return this.$store.getters['auth/isLogin'];
    }
  },
  created: async function() {

    this.redirectUrl = Object.keys(this.$route.query).includes('redirect')?this.$route.query['redirect']:'';

    // ログイン状態時
    // ※ログイン状態が残っている場合はログイン画面のリンクから遷移してもこちらに入ってきてしまうため
    //   若干違和感のある動作になっているが、問題なしとする
    //   (ログインしている状態で別タブでログイン画面を表示した場合や、
    //    ログイン後ログアウトせずタブを閉じてから再度ログイン画面を開いた場合など)
    if (this.isLogin) {
      this.isProcessing = true;
      const authority = await this.$store.dispatch('auth/getAuthority');
      this.isAdmin = authority.isAdmin;
      this.isSupple = authority.isSupple;
      this.isProcessing = false;
    }
    // 未ログイン状態時
    else {
      this.isSupple = Object.keys(this.$route.query).includes('supple');
    }
  },
  methods: {
    async agree() {
      if (!this.scrolled) return;
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/auth/updateTerms', {});
      if (res) {
        if ( this.redirectUrl ) {
          this.$router.push({ path: this.redirectUrl });
        }else{
          this.$router.push({ name: 'top' });
        }
      }
      this.isProcessing = false;
    },
    disagree() {
      this.$store.dispatch('auth/disagreeTerms', {isSupple: this.isSupple}).then(() => {});
    },
    emitScrolled() {
      this.scrolled = true;
    },
  }
}

</script>

<style scoped>
.gray-out {
  pointer-events: none;
}

.gray-out a {
  border: 1px solid #6a6a6a;
  color: #6a6a6a;
  background-color: #ffffff;
}

</style>
